<template>
<div class="animated fadeIn">
  <b-card no-body>
    <b-card-body>
      <b-row>
        <b-col lg="12">
          <!--<h6>Simple Form</h6>-->
          <b-form v-on:submit.prevent="onSubmit" v-on:reset.prevent="onReset" novalidate>

            <b-form-group label="Room Number" label-for="roomNumber">
              <b-form-input id="roomNumber" type="number" aria-describedby="liveFeedbackRoomNumber" v-model.lazy.trim="$v.form.roomNumber.$model" placeholder="Room Number" autofocus />
              <b-form-invalid-feedback id="liveFeedbackRoomNumber">
                This is a required field.
              </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group label="Bhent" label-for="price">
              <b-form-input id="price" type="number" aria-describedby="liveFeedbackPrice" v-model.lazy.trim="$v.form.price.$model" placeholder="Number of Beds" />
              <b-form-invalid-feedback id="liveFeedbackPrice">
                This is a required field.
              </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group label="Number of Beds" label-for="numberOfBeds">
              <b-form-input id="numberOfBeds" type="number" aria-describedby="liveFeedbackNumberOfBeds" v-model.lazy.trim="$v.form.numberOfBeds.$model" placeholder="Number of Beds" />
              <b-form-invalid-feedback id="liveFeedbackNumberOfBeds">
                This is a required field.
              </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group label="Max Occupiers" label-for="maxOccupiers">
              <b-form-input id="maxOccupiers" type="number" aria-describedby="liveFeedbackMaxOccupiers" v-model.lazy.trim="$v.form.maxOccupiers.$model" placeholder="Max Occupiers" />
              <b-form-invalid-feedback id="liveFeedbackMaxOccupiers">
                This is a required field.
              </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group label="Has Toilet?" label-cols-sm="4" label-cols-lg="3">
              <b-form-radio-group v-model="$v.form.hasToilet.$model" class="pt-2" :state="chkState('hasToilet')">
                <b-form-radio value="1">Yes</b-form-radio>
                <b-form-radio value="0">No</b-form-radio>
              </b-form-radio-group>
            </b-form-group>

            <b-form-group label="Has AC?" label-cols-sm="4" label-cols-lg="3">
              <b-form-radio-group v-model="$v.form.hasAC.$model" class="pt-2" :state="chkState('hasAC')">
                <b-form-radio value="1">Yes</b-form-radio>
                <b-form-radio value="0">No</b-form-radio>
              </b-form-radio-group>
            </b-form-group>

            <b-button type="submit" variant="primary" :disabled="$v.form.$invalid">
              Submit
            </b-button>
            <b-button class="ml-1" type="reset" @click="onCancel">Cancel</b-button>
          </b-form>
          <br />
        </b-col>
      </b-row>
    </b-card-body>
  </b-card>
</div>
</template>

<script>
import Vue from 'vue'
import {
  mapState,
  mapActions
} from 'vuex'
import {
  required
} from "vuelidate/lib/validators"

const formShape = {
  roomNumber: "",
  price: 0,
  numberOfBeds: null,
  maxOccupiers: null,
  hasToilet: null,
  hasAC: null
}

export default {
  name: "RoomFormAdd",
  data() {
    return {
      form: Object.assign({}, formShape),
      submitted: false
    }
  },
  computed: {
    isValid() {
      return !this.$v.form.$anyError
    },
    isDirty() {
      return this.$v.form.$anyDirty
    }
  },
  validations: {
    form: {
      roomNumber: {
        required
      },
      price: {
        required
      },
      numberOfBeds: {
        required
      },
      maxOccupiers: {
        required
      },
      hasToilet: {
        required
      },
      hasAC: {
        required
      }
    }
  },
  methods: {
    onSubmit() {
      if (this.validate()) {
        this.$nextTick(() => {
          this.submitted = true
          let params = {
            building_id: this.$route.params.building_id,
            floor_id: this.$route.params.floor_id,
            room_number: this.$v.form.roomNumber.$model,
            price: this.$v.form.price.$model,
            number_of_beds: this.$v.form.numberOfBeds.$model,
            max_occupiers: this.$v.form.maxOccupiers.$model,
            has_toilet: this.$v.form.hasToilet.$model,
            has_ac: this.$v.form.hasAC.$model,
          }

          this.$store.dispatch('rooms/addRoom', params)
            .then(() => {
              this.$emit('success')
              this.showSuccessMsg()
            })
            .catch((error) => {
              if (error.response.status == 400) {
                this.showErrorMsg({
                  message: error.response.data.message
                })
              } else {
                this.showErrorMsg()
              }
            })
        })
      }
    },
    onCancel() {
      this.$emit('cancel')
    },
    onReset() {
      // Reset validation
      this.form = formShape
      this.submitted = false
      this.$nextTick(() => {
        this.$v.$reset()
      })
    },
    chkState(val) {
      const field = this.$v.form[val]
      return field.$dirty ? !field.$invalid : null
    },
    findFirstError(component = this) {
      if (component.state === false) {
        if (component.$refs.input) {
          component.$refs.input.focus()
          return true
        }
        if (component.$refs.check) {
          component.$refs.check.focus()
          return true
        }
      }
      let focused = false
      component.$children.some((child) => {
        focused = this.findFirstError(child)
        return focused
      })

      return focused
    },
    validate() {
      this.$v.$touch()
      this.$nextTick(() => this.findFirstError())
      return this.isValid
    }
  }
}
</script>
